/** Legacy strings for إحصائيات عامة — Admin/General.ar.resx, LearningProgramsReports, Resources. */
export const strings = {
  title: 'إحصائيات عامة', // Sitemap.GeneralStatistics_Title
  subtitle: 'تفاصيل عامة', // General.SubPanelTitle
  hello: 'مرحبا، ', // Resources.Hello

  filter: {
    from: 'من', // Resources.Date_From
    to: 'إلى', // Resources.Date_To
    submit: 'التقرير', // Resources.Report
  },

  /** The four dials. The two notes are tooltips in the legacy. */
  shares: {
    success: 'نسبة النجاح', // LearningProgramsReports.LocSuccessPercentage
    failure: 'نسبة الرسوب', // LocFailurePercentage
    incomplete: 'نسبة عدم الاكتمال', // LocUncompletedPercentage
    incompleteNote: '(حضر اختبار واحد على الأقل و لم يكمل باقي الاختبارات)', // LocUncompletedPercentageNote
    absent: 'نسبة عدم الحضور', // LocUnattendedPercentage
    absentNote: '(من لم يحضر أي اختبار)', // LocUnattendedPercentageNote
  },

  counters: {
    programs: 'البرامج التدريبية', // General.ProgramsText
    courses: 'الدورات التدريبية', // General.CoursesText
    categories: 'المحتوى التعليمي', // General.CategoriesText
    activePrograms: 'البرامج النشطة', // General.ActivePrograms
    activeCourses: 'الدورات النشطة', // General.ActiveCourses
    remainingAccounts: 'الحسابات المتبقية', // General.RemainingAccountsText
    consumedAccounts: 'الحسابات المستخدمة', // General.ConsumedAccountsText
    remainingDays: 'الأيام المتبقية', // General.RemainingDaysText
    expiresOn: 'تاريخ نهاية الرخصة', // General.ExpirationDateText
  },

  /** The licence band. Every label is one the licence screen already uses. */
  license: {
    title: 'الرخصة', // Sitemap.AdminLicenseManagementTitle
    hint: 'عرض تفاصيل الترخيص', // AdminLicenseManagement.SubPanelTitle
    seats: 'الحسابات المتبقية', // General.RemainingAccountsText
    seatsUsed: 'المستخدمة', // General.ConsumedAccountsText
    days: 'الأيام المتبقية', // General.RemainingDaysText
    expiresOn: 'تنتهي في', // General.ExpirationDateText
  },

  /** Series names, shared by the bar chart and the programme table. */
  series: {
    success: 'عدد  الناجحين', // LocSuccessCount
    failure: 'عدد  الراسبين', // LocFailureCount
    incomplete: 'عدد من لم يكمل', // LocUncompletedCount
    absent: 'عدد عدم الحضور', // LocUnattendedCount
    passed: 'عدد الناجحين', // General.LearningProgramGeneralInfoReport.PassedCount
    failed: 'عدد الراسبين', // General.LearningProgramGeneralInfoReport.FailedCount
  },

  charts: {
    /* (النشطة) for the same reason the table below carries it — the bars are the same
       `programOutcomes` rows, active programmes only. */
    programs: 'إحصائيات البرامج التدريبية (النشطة)', // Resources.Learning_Programs_Statistics
    programsNote: 'يوضح الرسم البياني عدد المستخدمين وحالتهم لكل من البرامج التدريبية',
    exams: 'معدل الناجحين والراسبين', // Resources.Rate_of_Success_and_Failure
    assessments: 'معدل الناجحين والراسبين لاختبارات القياس', // Resources.AssessmentRate_of_Success_and_Failure
    period: 'الفترة', // Resources.Period
    /* Said only on the assessments chart: its handler takes no date range, so the picker above
       does not reach it. */
    allTime: 'لا يتأثر بالفترة المحددة',
    noAssessments: 'لا توجد اختبارات قياس',
  },

  loadFailed: 'تعذر تحميل الإحصائيات',
  notPermitted: 'لا تملك صلاحية عرض الإحصائيات',
  notPermittedHint: 'هذه الشاشة متاحة لمسؤولي إدارة العميل.',

  table: {
    /* (النشطة) is not the legacy's — the rows come from `ProgrammesInScope`, which filters
       on `p.IsActive`, so a suspended programme is absent from the table while the
       `البرامج التدريبية` counter above still counts it. The title said so nowhere. */
    title: 'تفاصيل البرامج التدريبية (النشطة)', // General.ProgramGeneralDetailsTitle
    subtitle: 'الدورات', // General.NavbarCourses
    program: 'البرنامج التدريبي',
  },

  /**
   * مؤشرات أداء المنصة — the platform-KPI block.
   *
   * The indicator SET is the legacy's (Views/General/Kpi.cshtml on develop,
   * "Added Kpis Report"), whose Arabic is written inline in the view rather than
   * through a resx. The STRUCTURE — four health dials over three domain tabs —
   * is the rawam-ui reference panel's, so the wording for the pieces the legacy
   * view has no equivalent of (the funnel stages, the trailing-activity window)
   * follows that panel.
   */
  kpis: {
    title: 'مؤشرات أداء المنصة',
    refresh: 'تحديث المؤشرات',
    refreshed: 'تم تحديث المؤشرات',
    error: 'حدث خطأ في تحميل المؤشرات. يرجى المحاولة لاحقا.',
    retry: 'إعادة المحاولة',
    /* The snapshot is one raw SQL query and it takes about ten seconds every time — the
       cache it is meant to have is not working. Ten seconds of a bare skeleton reads as a
       stuck page, so after six it says what it is doing. */
    slow: 'ما زال تحميل المؤشرات جاريا، وقد يستغرق بضع ثوان',

    groups: {
      participation: 'المشاركة والتغطية',
      completion: 'إكمال المحتوى',
      knowledge: 'المعرفة والاختبارات',
      compliance: 'الالتزام والسياسات',
    },

    /** The four dials, in the order a programme progresses. */
    headline: {
      title: 'مؤشرات أداء المنصة',
      activeRate: 'نسبة المستخدمين النشطين',
      activeRateUnit: 'موظف مستهدف',
      activeRateHint: 'نسبة الموظفين الذين سجلوا دخولا خلال الفترة المحددة من إجمالي الموظفين المستهدفين.',
      pathCompletionRate: 'نسبة إكمال المسارات',
      pathCompletionUnit: 'مسار مسند',
      pathCompletionHint: 'نسبة المسارات المكتملة من إجمالي المسارات المسندة للموظفين، لكل الفترات.',
      averageExamScore: 'متوسط درجات الاختبارات',
      averageScoreUnit: 'محاولة اختبار',
      averageScoreHint: 'متوسط درجات محاولات الاختبار المحتسبة، لكل الفترات.',
      complianceRate: 'نسبة إقرار السياسات',
      complianceUnit: 'إقرار مستهدف',
      complianceHint: 'نسبة الإقرارات المكتملة من إجمالي الإقرارات المستهدفة، لكل الفترات.',
    },

    /** The trailing window that defines an ACTIVE employee. */
    scope: {
      window: 'فترة النشاط',
      lastFew: 'آخر',
      daysFew: 'أيام',
      daysMany: 'يوما',
      windowHint:
        'تحدد هذه الفترة من يحتسب مستخدما نشطا فقط. أما إكمال المحتوى والاختبارات وإقرار السياسات فتحتسب لكل الفترات.',
    },

    totalTargeted: 'إجمالي الموظفين المستهدفين',
    registered: 'الموظفون المسجلون',
    activeEmployees: 'الموظفون النشطون',
    participatingDepartments: 'الإدارات المشاركة',

    publishedPaths: 'المسارات المنشورة',
    employeesStarted: 'الموظفون الذين بدأوا المحتوى',
    employeesCompleted: 'الموظفون الذين أكملوا مسار',
    employeesPassed: 'الموظفون الناجحون في المسارات',

    policyTargets: 'الإقرارات المستهدفة',
    acknowledgedTargets: 'الأهداف المقرة',
    pendingAck: 'الإقرارات المعلقة',
    feedback: 'الموظفون الذين قدموا ملاحظات',

    /** The participation funnel — one population narrowing, on one scope. */
    funnel: {
      title: 'مسار المشاركة',
      scope: 'لكل الفترات',
      targeted: 'المستهدفون',
      started: 'بدأوا المحتوى',
      completed: 'أكملوا مسارا',
      passed: 'نجحوا في مسار',
    },

    departments: {
      title: 'الإدارات الأكثر تفاعلا',
      scope: 'مرتبة من الأعلى إلى الأدنى',
      /* The API returns the top five and the bottom five, not every department. */
      partial: 'الأعلى والأدنى تفاعلا فقط',
      seriesActive: 'نشط',
      seriesInactive: 'غير نشط',
      emptyTitle: 'لا توجد إدارات لعرضها',
    },

    paths: {
      title: 'المسارات حسب نسبة الإكمال',
      scope: 'مرتبة من الأعلى إلى الأدنى',
      seriesCompleted: 'أكملوا',
      seriesRemaining: 'لم يكملوا',
      emptyTitle: 'لا توجد مسارات لعرضها',
    },

    complianceByDept: {
      title: 'إقرار السياسات حسب الإدارة',
      scope: 'مرتبة من الأدنى إلى الأعلى',
      seriesAcknowledged: 'أقروا',
      seriesPending: 'لم يقروا',
      emptyTitle: 'لا توجد بيانات إقرار لعرضها',
    },

    empty: { desc: 'لا توجد بيانات كافية لعرض هذا المؤشر.' },
  },

  /** The statistics on their own page — the fullscreen board and the printed report. */
  report: {
    title: 'الإحصائيات العامة',
    period: 'الفترة',
    allTime: 'كل الفترات',
    generatedAt: 'تاريخ التقرير',
    generatedBy: 'أعد بواسطة',
    fullscreen: 'ملء الشاشة',
    exitFullscreen: 'إنهاء ملء الشاشة',
    print: 'حفظ كملف PDF',
    failed: 'تعذر تحميل الإحصائيات',
    footer: 'روام — منصة التوعية بالأمن السيبراني',
    outcomesNote: 'نسب نتائج المتدربين في جميع البرامج التدريبية',
    sections: {
      platform: 'محتوى المنصة',
      licence: 'الرخصة',
      outcomes: 'نتائج المتدربين',
      gaps: 'مؤشرات المتابعة',
    },
    /** The exported file — a document, with a cover, not a photograph of the board. */
    document: {
      eyebrow: 'تقرير دوري',
      subtitle: 'تقرير شامل عن نشاط منصة التوعية بالأمن السيبراني، يغطي المحتوى التدريبي ونتائج المتدربين ومؤشرات الأداء والالتزام بالسياسات.',
      summary: 'ملخص تنفيذي',
      summaryNote: 'أربعة مؤشرات رئيسية تلخص حالة المنصة، ثم تفاصيلها في الصفحات التالية.',
      content: 'المحتوى المتاح على المنصة',
      seatsUsed: 'الحسابات المستخدمة',
      daysUsed: 'المدة المستهلكة من الرخصة',
      remaining: 'متبق',
      confidential: 'وثيقة داخلية',
    },
    progress: {
      title: 'جار إعداد التقرير',
      note: 'يتم الآن تجميع الإحصائيات ورسم المخططات وبناء صفحات التقرير. يرجى الانتظار وعدم إغلاق الصفحة.',
      steps: {
        data: 'قراءة الإحصائيات من الخادم…',
        charts: 'رسم المخططات…',
        render: 'تجهيز صفحات التقرير…',
        compose: 'بناء ملف PDF…',
        save: 'حفظ الملف…',
      },
    },
    preparing: 'جار إعداد التقرير…',
    prepared: 'تم تنزيل التقرير',
    exportFailed: 'تعذر إعداد التقرير',
    licence: { type: 'نوع الرخصة', seats: 'إجمالي الحسابات' },
    gaps: {
      notWatching: 'مستخدمون لم يشاهدوا المحتوى',
      notUpdatedProfile: 'مستخدمون لم يحدثوا ملفهم الشخصي',
    },
    table: {
      start: 'تاريخ البداية',
      end: 'تاريخ النهاية',
      groups: 'الإدارات',
      users: 'المستخدمون',
      empty: 'لا توجد برامج تدريبية',
    },
  },

  fullScreen: 'عرض ملء الشاشة',

  exportExcel: 'تصدير إلى أكسل',
  exportPdf: 'تصدير إلى PDF',
  noLicenceData: '—',
}
